<template>
<div class="d-flex flex-column h-100">

	<auction-header></auction-header>

	<div class="container-fluid flex-grow-1">

		<div class="row h-100">

			<div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 bg-dark px-0">

				<auction-sidebar></auction-sidebar>

			</div>

			<div class="col-xs-12 col-sm-8 col-md-9 col-lg-10 mt-3">

				<b-breadcrumb :items="breadcrumb" />

				<router-view :aucdates="{start:activeAuction.start,end:activeAuction.end}"></router-view>
			</div>

		</div>

	</div>

</div>
</template>

<script>
import AuctionHeader from '@/components/layouts/includes/AuctionHeader';
import AuctionSidebar from '@/components/layouts/includes/AuctionSidebar';
import { mergeBreadcrumb } from '@/helpers/breadcrumb-helper';
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'Dashboard',
	components: {
		AuctionHeader,
		AuctionSidebar
	},
	data() {
		return {
			message: 'Dashboard'
		}
	},
	computed: {
		...mapGetters({
			'breadcrumb': 'breadcrumb/getFormatted',
			'activeAuction': 'activeAuction'
		})
	},
	methods: {
		...mapActions([
			'getAuction',
		]),

		getData(auctionId) {
			this.getAuction(auctionId);
		},

		initialize() {
			this.$watch(
				() => ({
					auction: this.activeAuction,
					route: this.$route
				}), ({ auction }) => {
					mergeBreadcrumb([{ meta: { title: auction.title } }]);
				}
			)

			this.getData(this.$route.params.auctionId);
		}
	},
	beforeRouteUpdate(to, from, next) {
		if (to.path !== from.path) {
			this.getData(to.params.auctionId);
		}
		next()
	},
	mounted() {
		this.initialize();
	}
}
</script>

<style lang="scss" scoped>
.full-height {
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// AuctionLayout.vue?6f07ca54